export default __webpack_public_path__ + "static/media/porcelain-pavers-pool-deck.cc0f578f.jpg";